export const COMPARISON_ENDPOINTS = {
  COMPARE: "/frontend/net-diff-work-live-city",
  PUBLICCOMPARE:"frontend/public/net-diff-work-live-city",
  FILTER: "/frontend/filter-city",
  COMPARE_CITY: "/frontend/city-comparison-calculation",
  COMPARE_CITY_ONLY: "/frontend/city-comparison-calculation-compare-only",
  USER_CITY: "/frontend/user-city-details",
  UPDATE_USER: "/frontend/user-state-city-change",
  HOSPITAL_INFO: "/frontend/hospital-info",
  HOSPITAL_INFO_PUBLIC: "/frontend/public/hospital-info",
  HOSPITAL_INFO_COUNT: "/frontend/hospital-info-count-insert",
  CHANGE_SALARY: "/frontend/change-salary-housing",
  CHECK_COMPARE_COUNT: "/frontend/check-comparison-city-count",
  MAP_ANALYTICS: "/frontend/map-analytics/track",
};

export default COMPARISON_ENDPOINTS;
